import React from "react";
import type { FormFieldProps } from "~/components/form";
import { VariableLookupText } from "~/components/form/VariableLookupText";
interface MultiLineTextInputProps extends FormFieldProps<string> {
    label: string;
    localNames?: string[];
    warning?: string;
    defaultValueIndicator: JSX.Element | undefined;
    validate?: ((value: string) => string) | ((value: string | null) => string);
    onValidate?(value: string): void;
}
const MultiLineTextInput: React.FC<MultiLineTextInputProps> = (props) => {
    const { value, label, localNames, warning, defaultValueIndicator, ...rest } = props;
    const formProps = { ...rest, label };
    return (<React.Fragment>
            <VariableLookupText value={value} localNames={localNames} warning={warning} multiline={true} {...formProps}/>
            {defaultValueIndicator}
        </React.Fragment>);
};
MultiLineTextInput.displayName = "MultiLineTextInput"
export default MultiLineTextInput;
